import React from 'react';
import { TagRelation } from '../types/tag/tagRelation';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface TagRelationContextProps {
  tagRelations: Map<string, TagRelation>;
  setTagRelations: (tags: Map<string, TagRelation>) => void;
  tagRelationsLoading: boolean;
}

const defaultContext: TagRelationContextProps = {
  tagRelations: new Map(),
  setTagRelations: () => {},
  tagRelationsLoading: false,
};

export const TagRelationContext = React.createContext<TagRelationContextProps>(defaultContext);

interface TagRelationState {
  items: Record<string, any>[];
  loading: boolean;
}

export const tagRelationSlice = createSlice({
  name: 'tagRelation',
  initialState: { items: [], loading: true } as TagRelationState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<TagRelation[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<TagRelation[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
